
    <main vid="16">
        
        <section class="container hero" vid="17">
            <div class="hero-content" vid="18">
                <span class="section-label" vid="19">NEXUS Driver Client v2.4</span>
                <h1 class="text-display" vid="20">Logistics,<br vid="21">engineered for the night shift.</h1>
                <p class="hero-desc" vid="22">Bypass the noise. The Nexus client provides drivers with system-level route optimization, sub-second telemetry, and cryptographic proof of delivery. Join the grid.</p>
                <div class="hero-ctas" vid="23">
                    <button class="btn-primary btn-large flex-row" style="gap: 8px;" vid="24">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" vid="25"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" vid="26"></path></svg>
                        Download Client
                    </button>
                    <button class="btn-secondary btn-large" vid="27">View Documentation</button>
                </div>
            </div>

            
            <div class="app-window glass-panel" vid="28">
                <div class="window-header" vid="29">
                    <div class="window-controls" vid="30">
                        <div class="control-dot dot-red" vid="31"></div>
                        <div class="control-dot dot-yellow" vid="32"></div>
                        <div class="control-dot dot-green" vid="33"></div>
                    </div>
                    <div class="window-title" vid="34">NEXUS_CLIENT_ACTIVE</div>
                    <div class="window-actions" vid="35">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" vid="36"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" vid="37"></path></svg>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" vid="38"><circle cx="12" cy="12" r="3" vid="39"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" vid="40"></path></svg>
                    </div>
                </div>
                <div class="window-body" vid="41">
                    
                    <div class="flex-row space-between" style="padding: 0 4px;" vid="42">
                        <div vid="43">
                            <div class="text-xl" vid="44">Route Alpha-7</div>
                            <div class="text-xs color-secondary" style="margin-top: 4px;" vid="45">EST. COMPLETION: 03:45 AM</div>
                        </div>
                        <div class="toggle" vid="46"></div>
                    </div>

                    <div class="settings-group" vid="47">
                        <div class="settings-row" vid="48">
                            <div class="settings-icon-wrap icon-red" vid="49">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" vid="50"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" vid="51"></path><circle cx="12" cy="10" r="3" vid="52"></circle></svg>
                            </div>
                            <div class="settings-text" vid="53">
                                <span class="settings-title" vid="54">Current Objective</span>
                                <span class="settings-subtitle" vid="55">Dropoff: 844 Sector West</span>
                            </div>
                            <div class="settings-value" vid="56">
                                2.4 mi
                                <svg class="chevron-right" viewBox="0 0 8 12" vid="57"><path d="M1 1l5 5-5 5" stroke="currentColor" stroke-width="2" fill="none" vid="58"></path></svg>
                            </div>
                        </div>
                        <div class="settings-row" vid="59">
                            <div class="settings-icon-wrap icon-gray" vid="60">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" vid="61"><polygon points="12 2 2 7 12 12 22 7 12 2" vid="62"></polygon><polyline points="2 17 12 22 22 17" vid="63"></polyline><polyline points="2 12 12 17 22 12" vid="64"></polyline></svg>
                            </div>
                            <div class="settings-text" vid="65">
                                <span class="settings-title" vid="66">Manifest Status</span>
                                <span class="settings-subtitle" vid="67">14 packages remaining</span>
                            </div>
                            <div class="settings-value" vid="68">
                                <span style="color: var(--accent-green); font-size: 13px;" vid="69">Optimal</span>
                                <svg class="chevron-right" viewBox="0 0 8 12" vid="70"><path d="M1 1l5 5-5 5" stroke="currentColor" stroke-width="2" fill="none" vid="71"></path></svg>
                            </div>
                        </div>
                    </div>

                    <div class="settings-group" vid="72">
                        <div class="settings-row" vid="73">
                            <div class="settings-icon-wrap icon-gray" vid="74">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" vid="75"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" vid="76"></path></svg>
                            </div>
                            <div class="settings-text" vid="77">
                                <span class="settings-title" vid="78">Proof of Delivery</span>
                                <span class="settings-subtitle" vid="79">Cryptographic signatures active</span>
                            </div>
                            <div class="settings-value" vid="80">
                                System
                                <svg class="chevron-right" viewBox="0 0 8 12" vid="81"><path d="M1 1l5 5-5 5" stroke="currentColor" stroke-width="2" fill="none" vid="82"></path></svg>
                            </div>
                        </div>
                        <div class="settings-row" vid="83">
                            <div class="settings-icon-wrap icon-gray" vid="84">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" vid="85"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12" vid="86"></polyline></svg>
                            </div>
                            <div class="settings-text" vid="87">
                                <span class="settings-title" vid="88">Telemetry Stream</span>
                                <span class="settings-subtitle" vid="89">Latency: 14ms (Node 4)</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        
        <section class="container" style="padding: 40px 0;" vid="90">
            <div class="section-header" vid="91">
                <h2 class="text-xl" vid="92">System Capabilities</h2>
                <p class="color-secondary" style="margin-top: 8px;" vid="93">Built on the iOS/macOS architecture paradigm for maximum driver efficiency.</p>
            </div>
            
            <div class="features-grid" vid="94">
                <div class="glass-panel feature-card" vid="95">
                    <div class="feature-icon" vid="96">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" vid="97"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" vid="98"></path><circle cx="12" cy="10" r="3" vid="99"></circle></svg>
                    </div>
                    <div vid="100">
                        <div class="feature-title" vid="101">Dynamic Pathfinding</div>
                        <div class="feature-desc" vid="102">Algorithms continuously recalculate based on live traffic, node congestion, and delivery windows. Never drive a dead mile.</div>
                    </div>
                </div>
                <div class="glass-panel feature-card" vid="103">
                    <div class="feature-icon" vid="104">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" vid="105"><circle cx="12" cy="12" r="10" vid="106"></circle><polyline points="12 6 12 12 16 14" vid="107"></polyline></svg>
                    </div>
                    <div vid="108">
                        <div class="feature-title" vid="109">Sub-Second Telemetry</div>
                        <div class="feature-desc" vid="110">Real-time GPS pinging ensures dispatch and the end-customer know exactly where the asset is, down to the meter.</div>
                    </div>
                </div>
                <div class="glass-panel feature-card" vid="111">
                    <div class="feature-icon" vid="112">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" vid="113"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" vid="114"></path></svg>
                    </div>
                    <div vid="115">
                        <div class="feature-title" vid="116">Cryptographic POD</div>
                        <div class="feature-desc" vid="117">Capture signatures, photos, and location metadata locked via hash to ensure indisputable proof of delivery.</div>
                    </div>
                </div>
            </div>
        </section>

        
        <section class="container map-section" vid="118">
            <div class="glass-panel map-container" vid="119">
                <div class="map-grid" vid="120"></div>
                
                
                <svg class="route-svg" viewBox="0 0 800 400" preserveAspectRatio="xMidYMid slice" vid="121">
                    <defs vid="122">
                        <filter id="glow" x="-20%" y="-20%" width="140%" height="140%" vid="123">
                            <feGaussianBlur stdDeviation="4" result="blur" vid="124"></feGaussianBlur>
                            <feComposite in="SourceGraphic" in2="blur" operator="over" vid="125"></feComposite>
                        </filter>
                    </defs>
                    
                    <path class="route-path" filter="url(#glow)" d="M100,300 L150,300 L150,220 L280,220 L280,150 L400,150 L400,80 L550,80 L550,180 L700,180 L700,250" vid="126"></path>
                    
                    
                    <circle cx="100" cy="300" r="4" fill="#636366" vid="127"></circle>
                    <circle cx="280" cy="220" r="4" fill="#636366" vid="128"></circle>
                    <circle cx="400" cy="80" r="4" fill="#636366" vid="129"></circle>
                    <circle cx="700" cy="250" r="6" fill="#fff" vid="130"></circle>
                </svg>

                <div class="pulse-dot" style="top: 37.5%; left: 50%;" vid="131"></div> 

                
                <div class="map-overlay-panel" vid="132">
                    <div class="text-xs color-secondary" style="margin-bottom: 12px;" vid="133">ACTIVE NODE LINK</div>
                    <div class="settings-group" style="background: rgba(0,0,0,0.4);" vid="134">
                        <div class="settings-row" style="padding: 8px 12px;" vid="135">
                            <div class="settings-text" vid="136">
                                <span class="settings-title" style="font-size: 13px;" vid="137">Unit 409 (J. Miller)</span>
                                <span class="settings-subtitle" vid="138">En route to Drop 8</span>
                            </div>
                            <div class="settings-value" style="font-size: 12px; color: var(--accent-green);" vid="139">
                                45 MPH
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        
        <section class="metrics-section" vid="140">
            <div class="container metrics-grid" vid="141">
                <div vid="142">
                    <div class="metric-value" vid="143">99.9%</div>
                    <div class="metric-label" vid="144">Uptime SLA</div>
                </div>
                <div vid="145">
                    <div class="metric-value" vid="146">12.4M</div>
                    <div class="metric-label" vid="147">Nodes Handled</div>
                </div>
                <div vid="148">
                    <div class="metric-value" vid="149">&lt; 15ms</div>
                    <div class="metric-label" vid="150">Telemetry Latency</div>
                </div>
                <div vid="151">
                    <div class="metric-value" vid="152">4.9/5</div>
                    <div class="metric-label" vid="153">Driver Rating</div>
                </div>
            </div>
        </section>

        
        <section class="container cta-section" vid="154">
            <div class="cta-content" vid="155">
                <div class="logo-mark" style="width: 32px; height: 32px; border-radius: 8px;" vid="156"></div>
                <h2 class="text-display" style="font-size: 40px;" vid="157">Ready to plug in?</h2>
                <p class="hero-desc" style="margin: 0;" vid="158">Download the client and begin the verification process to access the logistics grid.</p>
                <button class="btn-primary btn-large" style="padding: 16px 40px; font-size: 16px; margin-top: 16px;" vid="159">Initialize Driver Profile</button>
            </div>
        </section>
    </main>

    <footer vid="160">
        <div class="container footer-inner" vid="161">
            <div vid="162">© 2024 NEXUS Logistics Systems. All rights reserved.</div>
            <div style="display: flex; gap: 16px;" vid="163">
                <a href="#" style="color: var(--text-secondary); text-decoration: none;" vid="164">System Status: Operational</a>
                <a href="#" style="color: var(--text-secondary); text-decoration: none;" vid="165">Privacy Policy</a>
            </div>
        </div>
    </footer>
